var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.dependencies),function(p){return _c('li',{key:p},[_vm._v("\n      "+_vm._s(p)+"\n    ")])}),0),_c('hr'),_c('div',{staticClass:"text-center"},[_c('powered-by-dark-sky')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }